// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SystemMessage_root__xzq8q {
  padding: 12px 0;
  text-align: center;
  cursor: default;
}

.SystemMessage_text__a9\\+9S {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #8E8E93;
}

.SystemMessage_profile__Xsedg {
  color: #4778EE;
  border: 0;
  display: inline;
  background: transparent;
  margin: 0 2px 0 3px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/SystemMessage/SystemMessage.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EAEA,kBAAA;EAEA,eAAA;AADF;;AAIA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADF;;AAIA;EACE,cAAA;EACA,SAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AADF","sourcesContent":[".root {\n  padding: 12px 0;\n\n  text-align: center;\n  //user-select: none;\n  cursor: default;\n}\n\n.text {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 14px;\n  color: #8E8E93;\n}\n\n.profile {\n  color: #4778EE;\n  border: 0;\n  display: inline;\n  background: transparent;\n  margin: 0 2px 0 3px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `SystemMessage_root__xzq8q`,
	"text": `SystemMessage_text__a9+9S`,
	"profile": `SystemMessage_profile__Xsedg`
};
export default ___CSS_LOADER_EXPORT___;
